import { render, staticRenderFns } from "./DashboardEmpresa.vue?vue&type=template&id=6775dd19&scoped=true"
import script from "./DashboardEmpresa.vue?vue&type=script&lang=js"
export * from "./DashboardEmpresa.vue?vue&type=script&lang=js"
import style0 from "./DashboardEmpresa.vue?vue&type=style&index=0&id=6775dd19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6775dd19",
  null
  
)

export default component.exports